import React, { useRef, useState, useEffect, useMemo } from "react";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import * as Yup from "yup";
import Offcanvas from "react-bootstrap/Offcanvas";
import { adminMainUrl } from "../../../../../Config";
import Select from "react-select";
import { customStyles } from "../../../../../HelperFunctions";
import { useDispatch } from "react-redux";
import { getMasterAccountSubGroupTypeIdAndName } from "../../../../../Redux/action/MasterAction";

const EditSubGroupType = ({
  state_id,
  show,
  handleClose,
  onSuccess,
  token,
  user_id,
  parentData,
  loadingParent,
  groupTypeData,
  loadingGroupType,
  loadingSubGroupTypeData,
  subGroupTypeData,
  MaterParentName,
  MasterGroupTypeName,
  refresh,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [parentOptions, setParentOptions] = useState([]);
  const [parentId, setParentId] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (parentData) {
      const arr = parentData.map((val) => ({
        value: val.id,
        label: val.name,
      }));
      setParentOptions(arr);
    }
  }, [parentData]);

  //  *   FORM VALIDATION
  const validationSchema = Yup.object({
    name: Yup.string().required("Sub Group Type is required."),
    // parent_id: Yup.string().required("Parent is required."),
    // group_id: Yup.string().required("Group Type is required."),
  });

  // console.log("subGroupTypeData", subGroupTypeData);

  const filteredGroupTypeOptions = useMemo(() => {
    if (!parentId || !groupTypeData) return [];

    return groupTypeData
      .filter((g) => g.parent_group_id == parentId)
      .map((item) => ({
        value: item.id,
        label: item.name,
      }));
  }, [parentId, groupTypeData]);

  const formik = useFormik({
    initialValues: {
      id: state_id,
      name: subGroupTypeData?.name || "",
      // parent_id: "",
      // group_id: "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      console.log("values", values);

      setIsSubmitting(true);
      try {
        const response = await fetch(
          `${adminMainUrl}/api/account/sub-group-type`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "auth-token": token,
              user_id: user_id,
            },
            body: JSON.stringify(values),
          }
        );

        const data = await response.json();

        if (response.ok) {
          refresh();
          dispatch(getMasterAccountSubGroupTypeIdAndName(token, user_id));

          toast.success(data?.msg);
          if (onSuccess) onSuccess();
          handleClose();
        } else {
          toast.error(data?.msg);
        }
      } catch (error) {
        toast.error("Network error");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  /** ------------------------------
   *   PREFILL FORM VALUES WHEN groupTypeData ARRIVES
   * ------------------------------ */
  useEffect(() => {
    if (!groupTypeData) return;

    formik.setFieldValue("name", groupTypeData.name);
    formik.setFieldValue("parent_id", groupTypeData.parent_group_id);
    setParentId(groupTypeData.parent_group_id);
    formik.setFieldValue("group_id", groupTypeData.group_type_id);
  }, [groupTypeData]);

  return (
    <Offcanvas
      className="custom-offcanvas"
      show={show}
      onHide={handleClose}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Edit Sub Group Type</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            {/* Sub Group Type Name */}
            <div className="col-12 mt-2">
              <label className="form-label">
                Sub Group Type <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name && (
                <div className="error">{formik.errors.name}</div>
              )}
            </div>

            {/* Parent Select */}
            {/* <div className="col-12 mt-2">
              <label className="form-label mb-0">Parent</label>
              <Select
                className="custom-selector"
                options={parentOptions}
                styles={customStyles}
                name="parent_id"
                onChange={(opt) => {
                  formik.setFieldValue("parent_id", opt.value);
                  setParentId(opt.value);
                }}
                value={
                  parentOptions.find(
                    (p) => p.value == formik.values.parent_id
                  ) || null
                }
                isLoading={loadingParent}
              />
              {formik.touched.parent_id && formik.errors.parent_id && (
                <div className="error">{formik.errors.parent_id}</div>
              )}
            </div> */}

            {/* Group Type Select */}
            {/* <div className="col-12 mt-2">
              <label className="form-label mb-0">Group Type</label>
              <Select
                className="custom-selector"
                options={filteredGroupTypeOptions}
                styles={customStyles}
                name="group_id"
                onChange={(opt) => {
                  formik.setFieldValue("group_id", opt.value);
                }}
                value={
                  filteredGroupTypeOptions.find(
                    (g) => g.value == formik.values.group_id
                  ) || null
                }
                isLoading={loadingGroupType}
              />
              {formik.touched.group_id && formik.errors.group_id && (
                <div className="error">{formik.errors.group_id}</div>
              )}
            </div> */}

            <div className="col-12 mt-2">
              <label className="form-label">Parent</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="parent"
                value={MaterParentName}
                disabled={true}
              />
            </div>

            <div className="col-12 mt-2">
              <label className="form-label">Group Type</label>
              <input
                type="text"
                className="form-control form-control-sm"
                name="parent"
                value={MasterGroupTypeName}
                disabled={true}
              />
            </div>
          </div>

          {/* Submit Button */}
          <div className="row d-flex justify-content-end mt-4">
            <div className="col-md-6 d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-sm btn-danger"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Updating...
                  </>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EditSubGroupType;
